"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameTitle = void 0;
/**
 * @deprecated since 1.4.271, use `GameEntity.title`
 */
var GameTitle;
(function (GameTitle) {
    GameTitle["DeliveryDash"] = "Delivery Dash";
    GameTitle["Lol"] = "League of Legends";
    GameTitle["Lichess"] = "Lichess";
    GameTitle["Lidraughts"] = "Lidraughts";
})(GameTitle = exports.GameTitle || (exports.GameTitle = {}));
//# sourceMappingURL=game-title.js.map